
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function SaaSSoftware() {
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'SaaS & Software Commercial Outcomes - Negotrix | 15-25% Improvement';
    setTimeout(() => setIsVisible(true), 100);
  }, []);

  return (
    <div className={`min-h-screen bg-cipher-black text-white transition-opacity duration-700 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
      <Header />

      {/* Hero */}
      <section className="pt-40 pb-24 px-6 lg:px-12">
        <div className="max-w-[1400px] mx-auto">
          <h2 className="text-sm tracking-widest uppercase text-cipher-hypergreen font-bold mb-6">Cost Category</h2>
          <h1 className="text-[8vw] leading-[0.9] font-black tracking-tighter mb-12">
            <span className="text-white">SaaS &</span><br />
            <span className="text-cipher-hypergreen">Software.</span>
          </h1>
          <div className="flex items-center gap-6 mb-10">
            <div className="text-5xl font-black text-cipher-hypergreen">25–40%</div>
              <div className="text-gray-400 text-xl">average commercial improvement<br />from SaaS contracts</div>
          </div>
          <p className="text-xl text-gray-400 max-w-2xl">
             Identify unused licenses, consolidate duplicate tools, and right-size enterprise agreements, without disrupting operations.
          </p>
        </div>
      </section>

      {/* What We Do */}
      <section className="py-24 bg-cipher-dark border-t border-gray-900">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <h2 className="text-sm tracking-widest uppercase text-cipher-hypergreen font-bold mb-16">What We Do</h2>
          <div className="border-t border-gray-800">
            {[
               { title: 'License Audit & Contract Strategy', desc: 'We map every active license against actual usage data to identify unused seats, overpaid tiers, and zombie subscriptions, often finding 20–35% of licenses are underutilized.' },
              { title: 'Contract Renegotiation', desc: 'We negotiate directly with SaaS vendors using current market benchmarks and your usage data to secure significantly better pricing, even mid-contract.' },
              { title: 'Tool Consolidation Analysis', desc: 'We identify overlapping tools performing the same function across departments and create a consolidation roadmap that reduces complexity and cost.' },
               { title: 'Renewal Management', desc: 'We prevent unfavorable auto-renewals by tracking all contract end dates and negotiating proactively, typically 60–90 days before renewal.' },
            ].map((item, i) => (
              <div key={i} className="group border-b border-gray-800 py-12 hover:bg-cipher-black transition-colors px-6 -mx-6">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start">
                  <div className="lg:col-span-1 text-gray-600 font-black text-xl">0{i + 1}</div>
                  <div className="lg:col-span-4 text-2xl lg:text-3xl font-black group-hover:text-cipher-hypergreen transition-colors">{item.title}</div>
                  <div className="lg:col-span-7 text-gray-400 text-lg">{item.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-24 bg-cipher-black border-t border-gray-900">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              { val: 'Direct', label: 'Vendor Negotiation' },
              { val: 'No', label: 'Upfront Fees' },
              { val: 'Only', label: 'On Results' }
            ].map((s, i) => (
              <div key={i} className="p-8 bg-cipher-dark rounded-[2rem] border border-gray-800">
                <div className="text-5xl lg:text-6xl font-black text-cipher-hypergreen mb-4">{s.val}</div>
                <div className="text-sm tracking-widest uppercase text-gray-500 font-bold">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-32 lg:py-48 bg-cipher-dark border-t border-gray-800">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 text-center">
          <h2 className="text-[8vw] leading-[0.9] font-black tracking-tighter text-white mb-12">
             Take control of<br /><span className="text-cipher-hypergreen">SaaS contracts today.</span>
          </h2>
          <button
            onClick={() => navigate('/contact')}
            className="inline-flex items-center justify-center px-10 py-5 text-lg tracking-wide font-bold uppercase rounded-full text-cipher-black bg-cipher-hypergreen hover:bg-white transition-all duration-300"
          >
             Start Your Commercial Review
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
}
